export const NAV_ITEMS = [
  { key: "stories", label: "STORIES", href: "/stories" },
  { key: "photography", label: "PHOTOGRAPHY", href: "/photography" },
  { key: "video", label: "VIDEO", href: "/videos" },
  { key: "projects", label: "PROJECTS", href: "/projects" },
  { key: "blog", label: "BLOG", href: "/blog" },
  { key: "about", label: "ABOUT", href: "/about" },
  { key: "cjjayamahas-cv", label: "CV", href: "/CJJayamahas-CV" },
  { key: "buy", label: "BUY", href: "/buy" },
];

export const FOOTER_QUICK_LINKS = [
  { key: "stories", label: "Stories", href: "/stories" },
  { key: "photography", label: "Photography", href: "/photography" },
  { key: "video", label: "Video", href: "/videos" },
  { key: "projects", label: "Projects", href: "/projects" },
  { key: "blog", label: "Blog", href: "/blog" },
];

export const FOOTER_INFO_LINKS = [
  { key: "about", label: "About", href: "/about" },
  { key: "cjjayamahas-cv", label: "CV", href: "/CJJayamahas-CV" },
  { key: "contact", label: "Contact", href: "/contact" },
  { key: "albums", label: "Albums", href: "/albums" },
  { key: "buy", label: "Buy", href: "/buy" },
  { key: "licensing", label: "Licensing", href: "/licensing" },
];

/** @param {string} pathname */
export function getNavCurrent(pathname) {
  if (pathname === "/") return "home";

  const segment = pathname.replace(/^\//, "").split("/")[0];
  const map = {
    stories: "stories",
    photography: "photography",
    videos: "video",
    projects: "projects",
    blog: "blog",
    about: "about",
    "CJJayamahas-CV": "cjjayamahas-cv",
    cv: "cjjayamahas-cv",
    buy: "buy",
    contact: "contact",
    albums: "albums",
    licensing: "licensing",
    gallery: "photography",
  };

  return map[segment] ?? "home";
}
